(function () {
  'use strict';
  var wide = window.matchMedia('(min-width: 1280px) and (orientation: landscape)');
  function initialize() {
    document.querySelectorAll('body.template-product .single-product:not(.bioss-loading-kit)').forEach(function (root) {
      if (root.dataset.biossLandscapeReady) return;
      root.dataset.biossLandscapeReady = 'true';
      var aside = root.querySelector('.product-aside');
      var purchase = aside && aside.querySelector(':scope > .purchase-box');
      var anchor;
      if (purchase) {
        anchor = document.createComment('bioss-landscape-purchase');
        aside.insertBefore(anchor, purchase);
      }
      var galleries = Array.from(root.querySelectorAll('.images-container'));
      var controls = new Map();
      function sync() {
        if (purchase && anchor.parentNode) {
          if (wide.matches) {
            if (aside.firstElementChild !== purchase) aside.insertBefore(purchase, aside.firstChild);
          } else if (anchor.nextSibling !== purchase) {
            anchor.parentNode.insertBefore(purchase, anchor.nextSibling);
          }
        }
        galleries.forEach(function (host) {
          var toolbar = host.querySelector(':scope > .bioss-published-controls');
          if (!toolbar) return;
          if (!controls.has(toolbar)) {
            var marker = document.createComment('bioss-landscape-gallery-controls');
            host.insertBefore(marker, toolbar);
            controls.set(toolbar, marker);
          }
          var marker = controls.get(toolbar);
          if (wide.matches) {
            if (host.firstElementChild !== toolbar) host.insertBefore(toolbar, host.firstChild);
          } else if (marker.nextSibling !== toolbar) {
            marker.parentNode.insertBefore(toolbar, marker.nextSibling);
          }
        });
      }
      galleries.forEach(function (host) {
        new MutationObserver(sync).observe(host, {childList: true});
      });
      wide.addEventListener('change', sync);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
